module.exports = __webpack_public_path__ + "img/button-click-collect.e9790f93.png";